export enum ActionRequest {
    IMPORTED_REQUEST = 1,
    UPDATED_REQUEST = 2,
    SCHEDULED_REQUEST = 3,
    UPDATED_SCRIPT = 4,
    CHECK_RESPONSE_FORECAST = 5,
    RELEASE_PRODUCTION = 6,
}
